<ng-container [ngSwitch]="data?.form_type">
  <!-- PHONE NUMBER -->
  <div class="popup" *ngSwitchCase="ProfileDetailsType.PhoneNumber">
    <h1 class="popup__header" mat-dialog-title [translate]="'ProfileDetails:Delete'">Delete</h1>
    <div mat-dialog-content>
      <p class="popup__body">
        {{ translationKeys.phoneNumber[data?.type] | translate | titlecase }} &middot; {{ data?.title }}
      </p>
    </div>
  </div>

  <!-- ADDRESS -->
  <div class="popup" *ngSwitchCase="ProfileDetailsType.Address">
    <h1 class="popup__header" mat-dialog-title [translate]="'ProfileDetails:Delete'">Delete</h1>
    <div mat-dialog-content>
      <p class="popup__body">
        {{ translationKeys.address[data?.type] | translate | titlecase }} &middot; {{ data?.details }}
      </p>
    </div>
  </div>

  <!-- TRAVELLER -->
  <div class="popup" *ngSwitchCase="ProfileDetailsType.Traveller">
    <h1 class="popup__header" mat-dialog-title [translate]="'ProfileDetails:Delete'">Delete</h1>
    <div mat-dialog-content>
      <p class="popup__body">
        {{ translationKeys.traveller[data?.type] | translate }} &middot; {{ data?.title }}
        {{ data?.name | nameWithoutTitle }} &middot;
        {{ data?.details }}
      </p>
    </div>
  </div>

  <!-- SPECIAL OCCASION -->
  <div class="popup" *ngSwitchCase="ProfileDetailsType.SpecialOccasion">
    <h1 class="popup__header" mat-dialog-title [translate]="'ProfileDetails:Delete'">Delete</h1>
    <div mat-dialog-content>
      <p class="popup__body">
        {{ translationKeys.specialOccasion[data?.type] | translate | titlecase }} &middot; {{ data?.title }} &middot;
        {{ data?.details }}
      </p>
    </div>
  </div>

  <!-- PAYMENT CARD -->
  <div class="popup" *ngSwitchCase="ProfileDetailsType.PaymentCard">
    <h1 class="popup__header" mat-dialog-title [translate]="'ProfileDetails:Delete'">Delete</h1>
    <div mat-dialog-content>
      <p class="popup__body">{{ translationKeys.paymentCard | translate }} {{ data?.title | slice: -4 }}</p>
    </div>
  </div>
</ng-container>

<div class="btns" mat-dialog-actions>
  <button id="cancel-current-edit" class="btns__keep" mat-button (click)="onNoClick()">
    <span [translate]="'RequestDialogComponent:Cancel'">Cancel</span>
  </button>
  <button
    id="delete-current-record"
    class="btns__delete"
    mat-button
    [mat-dialog-close]="data.id"
    (click)="removeAndClose()"
    cdkFocusInitial
  >
    <span [translate]="'ProfileDetails:Delete'"> Delete </span>
  </button>
</div>
